import { Component } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { LOCALES } from '../../../../../../../common/models/main';
import { ApiService } from '../../../../../../../common/services/api.service';
import { CustomValidators } from '../../../../../../../common/shared/custom-validators';

@Component({
  selector: 'app-invite-member-modal',
  templateUrl: './invite-member-modal.component.html',
  styleUrls: ['./invite-member-modal.component.scss'],
})
export class InviteMemberModalComponent {
  form = this.fb.group({
    email: ['', [Validators.required, CustomValidators.validateEmail]],
    name: ['', [Validators.required]],
    locale: [LOCALES.ES, [Validators.required]],
    isAdmin: [false],
    isManager: [false],
    welcomeMessage: [''],
  });

  organizationId = '';
  sending = false;

  constructor(
    public dialogRef: MatDialogRef<InviteMemberModalComponent>,
    private fb: NonNullableFormBuilder,
    private api: ApiService,
  ) {}

  send(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.api.logError('formErrors.invalidForm');
      return;
    }

    const { email, name, locale, isAdmin, isManager, welcomeMessage } = this.form.getRawValue();
    this.sending = true;

    this.api.inviteMemberToOrganization({
      organizationId: this.organizationId,
      user: { email: email.trim(), name, locale, isAdmin, isManager },
      welcomeMessage,
    }).subscribe({
      next: () => {
        this.api.log('inviteMember.success', true);
        this.dialogRef.close(true);
      },
      error: (e) => {
        this.sending = false;
        if (e?.code === 'OrganizationProductLimit') {
          this.api.logWarn('inviteMember.errorProductLimit', true);
        } else {
          this.api.logError('inviteMember.errorSend', true);
        }
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
